import { Box, Button, Card, Flex, Text } from "@radix-ui/themes";
import { useUsage } from "../../contexts/UsageContext";
import { useBillingPortal } from "../../hooks/useBillingPortal";
import { CARD_STYLE } from "../dashboard/tokens";

export default function InvoicePortalCard() {
    const { hasInvoices, loading } = useUsage();
    const { opening, error, openPortal } = useBillingPortal();

    if (loading || !hasInvoices) {
        return null;
    }

    return (
        <Card size="3" mt="5" style={CARD_STYLE}>
            <Flex align="center" justify="between" gap="4" wrap="wrap">
                <Box>
                    <Text as="div" size="3" weight="medium">
                        Invoices
                    </Text>
                    <Text as="p" size="2" color="gray">
                        View and download your invoices in Stripe. Opens in a new tab.
                    </Text>
                </Box>
                <Button type="button" variant="outline" disabled={opening} onClick={() => openPortal()}>
                    {opening ? "Opening invoices…" : "View invoices"}
                </Button>
            </Flex>
            {error && (
                <Text as="p" size="2" color="red" mt="3" role="alert">
                    {error}
                </Text>
            )}
        </Card>
    );
}
